<template>
    <div
        v-if="post"
        id="page-single"
        class="m-page"
    >
        <y-container>
            <h1 class="typo-h6 mb-5 mt-10">
                {{ post.title }}
            </h1>
            <y-page-content
                :content="post.text"
                class="pb-15"
            />
        </y-container>
    </div>
</template>

<script>

    import PageMixin from '@nodes/mixins/Page';
    import { YPageContent } from '@components';

    export default {

        name: 'PageSingle',

        components: {
            YPageContent,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.get(this.post, 'title'),
            };
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                post: null,
            };
        },

        methods: {

            /**
             * Fetch page data
             * 
             * @returns {Promise}
             */
            fetch() {
                this.post = null;

                const params = {
                    type     : 'page',
                    slug     : this.$route.params.slug,
                    including: ['title', 'text'],
                    locale   : this.$i18n.locale,
                };
                return this.$services.Content.postSingle(params).then((response) => {
                    this.post = response.data.results;
                }).catch((error) => {
                    this.handleError(error);
                });
            },

        },

    };
</script>
